import type { JSX } from 'react';

import { PromotedImpressionTracker } from 'src/app/shared/components/promotionTracking';

import type { SuggestedPetition } from '../../../../shared/api';
import { PetitionCardViewTracker } from '../../../../shared/components/viewTracking';
import type { SuggestedPetitionSourceLocation } from '../../../../shared/types';

import { SuggestedPetitionCard } from './components/SuggestedPetitionCard';

type Props = Readonly<{
	petitions: readonly SuggestedPetition[];
	parentPetitionId?: string;
	sourceLocation: SuggestedPetitionSourceLocation;
}>;

export function SuggestedPetitionsList({ petitions, parentPetitionId, sourceLocation }: Props): JSX.Element | null {
	return (
		<div data-qa="suggested-petitions" className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
			{petitions.map((petition, index) => (
				<div key={petition.node.id}>
					{petition.promotionToken && (
						<PromotedImpressionTracker
							petitionId={petition.node.id}
							promotionToken={petition.promotionToken}
							placement={sourceLocation}
							algorithm={petition.algorithm}
						/>
					)}
					<PetitionCardViewTracker
						petitionId={petition.node.id}
						petitionStatus="open"
						parentPetitionId={parentPetitionId}
						gridPosition={index + 1}
						algorithm={petition.algorithm}
						// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
						strategy={petition.trackingData?.strategy}
					/>
					<SuggestedPetitionCard
						petition={petition}
						parentPetitionId={parentPetitionId}
						gridPosition={index + 1}
						sourceLocation={sourceLocation}
					/>
				</div>
			))}
		</div>
	);
}
